import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { DecodeToken } from 'utils/decodeToken';

import { PostEffectSchedule } from 'services/scheduling/postEffectSchedule';
import { GetOrdersByCustomerId } from 'services/scheduling/getOrdersByCustomerId';
import { PostBuscaTermoDeAdesao } from 'services/scheduling/postBuscaTermoDeAdesao';
import { GetOrderDetailScheduling } from 'services/scheduling/getOrderDetailScheduling';
import { PostGetListStoresByZipCode } from 'services/scheduling/postGetListStoresByZipCode';
import { PostGenerateReschedulingFee } from 'services/scheduling/postGenerateReschedulingFee';
import { PostAgendamentoDesinstalacao } from 'services/scheduling/postAgendamentoDesinstalacao';

import { ParamsBodyGetListStoresByZipCode, ParamsDataOrdersByCustomerId, ParamsDataOrderDetailScheduling, ParamsDataListStoresByZipCode, ParamsBodyEffectSchedule, ParamsDataGenerateReschedulingFee } from 'utils/typeServices';

const useScheduling = () => {
    const navigate = useNavigate();
    const [dataEffectSchedule, setDataEffectSchedule] = useState<boolean>();
    const [dataBuscaTermoDeAdesao, setDataBuscaTermoDeAdesao] = useState<boolean>();
    const [dataGenerateReschedulingFee, setDataGenerateReschedulingFee] = useState<ParamsDataGenerateReschedulingFee>();
    const [dataOrdersByCustomerId, setDataOrdersByCustomerId] = useState<Array<ParamsDataOrdersByCustomerId>>();
    const [dataOrderDetailScheduling, setDataOrderDetailScheduling] = useState<ParamsDataOrderDetailScheduling | false | null>();
    const [dataListStoresByZipCode, setDataListStoresByZipCode] = useState<Array<ParamsDataListStoresByZipCode> | false>();

    const handleClearScheduling = () => {
        setDataEffectSchedule(undefined);
        setDataOrdersByCustomerId(undefined);
        setDataListStoresByZipCode(undefined);
        setDataOrderDetailScheduling(undefined);
        setDataGenerateReschedulingFee(undefined);
    }

    const handleGetOrderDetailScheduling = async ({ token, cdPedido }: { token: string, cdPedido: string }) => {
        const { data } = await GetOrderDetailScheduling({ token, cdPedido });

        if (typeof data === 'object' && data) {
            setDataOrderDetailScheduling(data);
        } else if (data === false) {
            setDataOrderDetailScheduling(false);
        } else {
            setDataOrderDetailScheduling(null);
        }
    }

    const handlePostGetListStoresByZipCode = async ({ token, body }: { token: string, body: ParamsBodyGetListStoresByZipCode }) => {
        const { data } = await PostGetListStoresByZipCode({ token, body });

        if (data) {
            setDataListStoresByZipCode(data);
        } else {
            setDataListStoresByZipCode(false);
        }
    }

    const handleGetOrdersByCustomerId = async ({ token }: { token: string }) => {
        const { data } = await GetOrdersByCustomerId({ token });

        if (data) {
            setDataOrdersByCustomerId(data);
        }
    }

    const handlePostEffectSchedule = async ({ token, body, isExchanges = false, isWebView }: { token: string, body: ParamsBodyEffectSchedule, isExchanges?: boolean, isWebView: boolean }) => {
        setDataEffectSchedule(undefined);
        const { data } = await PostEffectSchedule({ token, body });

        if (data) {
            if (isExchanges) {
                navigate(`${isWebView ? '/wb' : ''}/central-de-trocas/troca-de-servico/resumo-pedido`);
            } else {
                if (dataOrderDetailScheduling && dataOrderDetailScheduling.TAXA_REAGENDAMENTO) {
                    const tokenDec = DecodeToken();
                    const { data: dataTicket } = await PostGenerateReschedulingFee({ token, body: { CD_PEDIDO_ITEM: dataOrderDetailScheduling.CD_PEDIDO_ITEM, customerUser: tokenDec.username_email } });

                    if (dataTicket) {
                        setDataGenerateReschedulingFee(dataTicket);
                    }
                    setDataEffectSchedule(true);
                } else {
                    setDataEffectSchedule(true);
                }
            }
        } else {
            setDataEffectSchedule(false);
            setTimeout(() => {
                setDataEffectSchedule(undefined);
                setDataListStoresByZipCode(undefined);
            }, 3000);
        }
    }

    const handlePostAgendamentoDesinstalacao = async ({ token, body, NR_PLATAFORMA }: { token: string, body: ParamsBodyEffectSchedule, NR_PLATAFORMA: number }) => {
        setDataEffectSchedule(undefined);
        const { data } = await PostAgendamentoDesinstalacao({ token, body, NR_PLATAFORMA });

        if (data) {
            setDataEffectSchedule(true);
            if (dataOrderDetailScheduling && dataOrderDetailScheduling.TAXA_REAGENDAMENTO) {
                const tokenDec = DecodeToken();
                const { data: dataTicket } = await PostGenerateReschedulingFee({ token, body: { CD_PEDIDO_ITEM: dataOrderDetailScheduling.CD_PEDIDO_ITEM, customerUser: tokenDec.username_email } });

                if (dataTicket) {
                    setDataGenerateReschedulingFee(dataTicket);
                }
            }
        } else {
            setDataEffectSchedule(false);
        }
    }

    const handlePostBuscaTermoDeAdesao = async ({ token, CD_AGENDAMENTO }: { token: string, CD_AGENDAMENTO: number }) => {
        setDataBuscaTermoDeAdesao(undefined);
        const { data } = await PostBuscaTermoDeAdesao({ token, CD_AGENDAMENTO });

        setDataBuscaTermoDeAdesao(data);
    }

    return { dataOrdersByCustomerId, dataOrderDetailScheduling, dataListStoresByZipCode, dataEffectSchedule, dataGenerateReschedulingFee, dataBuscaTermoDeAdesao, handleGetOrderDetailScheduling, handlePostGetListStoresByZipCode, handleGetOrdersByCustomerId, handlePostEffectSchedule, handleClearScheduling, handlePostAgendamentoDesinstalacao, handlePostBuscaTermoDeAdesao };
}

export default useScheduling;